export default "__VITE_ASSET__ByD_XmkG__"